import React from 'react';
import { Fixed, Flex, Box } from 'rebass';
import styled from 'styled-components';
import ArrowLeft from 'react-icons/lib/fa/long-arrow-left';
import Breakpoint from '../../app/components/breakpoint';
import Link from '../../app/components/link';

const MobileGoBack = styled(Fixed)`
  width: 100%;
`;

const MobileCloseLink = styled(Link)`
  text-decoration: none;
`;

const GoBack = () => (
  <Breakpoint mobile>
    <MobileGoBack
      top
      left
    >
      <Flex
        py={3}
        justify="center"
        bg="greyLight"
      >
        <MobileCloseLink
          to="/"
          color="grey"
        >
          <Flex>
            <ArrowLeft />
            <Box pl={2}>
              Go back to our clients list
            </Box>
          </Flex>
        </MobileCloseLink>
      </Flex>
    </MobileGoBack>
  </Breakpoint>
);

export default GoBack;



// WEBPACK FOOTER //
// ./src/Details/go_back/index.js